export default {
  CHANGE_ADDRESS: 'CHANGE_ADDRESS',
  CHANGE_DATE: 'CHANGE_DATE',
  CHANGE_DATE_AND_ADDRESS: 'CHANGE_DATE_AND_ADDRESS',
  CONTACT: 'CONTACT',
  MESSAGE: 'MESSAGE'
};
